import PageMetaData from "~/components/page-meta-data";
import { formatBlogDate } from "~/lib/helpers/date-helper";

import styles from '~/styles/pages/post.module.scss';

interface Props {
    post: any;
}

export default function BlogLayout({ post }: Props) {

    return (
        <div className={styles.post}>
            <PageMetaData
                title={post.title}
                description={post.preview}
                twitterCard="summary_large_image"
                photoUrl={post.thumb}
            />
            <h1 className={styles.title}>{post.title}</h1>
            <div className={styles.byline}>
                by <strong>{post.author}</strong> on {formatBlogDate(post.date)}
            </div>
            <div
                dangerouslySetInnerHTML={{
                    __html: post.content,
                }}
            />
        </div>
    );
}